const API = process.env.REACT_APP_API_BASE || 'https://sequentus-content.azurewebsites.net/api';

// Magic link login
export async function requestLoginLink(email: string) {
  const res = await fetch(`${API}/ss/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });
  return res.json();
}

// Session management
export async function createCheckoutSession(email: string, name: string, regulator: string) {
  const res = await fetch(`${API}/ss/checkout`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, name, regulator }),
  });
  return res.json();
}

export async function validateToken(token: string) {
  const res = await fetch(`${API}/ss/validate?token=${token}`);
  return res.json();
}

// Document upload
export async function uploadDocument(token: string, file: File) {
  const res = await fetch(`${API}/ss/upload`, {
    method: 'POST',
    headers: { 'x-session-token': token, 'x-filename': file.name, 'Content-Type': file.type || 'application/octet-stream' },
    body: file,
  });
  return res.json();
}

export async function getDocuments(token: string) {
  const res = await fetch(`${API}/ss/documents`, { headers: { 'x-session-token': token } });
  return res.json();
}

// Allegation extraction
export async function extractAllegations(token: string) {
  const res = await fetch(`${API}/ss/extract-allegations`, {
    method: 'POST',
    headers: { 'x-session-token': token },
  });
  return res.json();
}

// Allegation confirmation
export async function confirmAllegations(token: string, allegations: any[]) {
  const res = await fetch(`${API}/ss/confirm-allegations`, {
    method: 'POST',
    headers: { 'x-session-token': token, 'Content-Type': 'application/json' },
    body: JSON.stringify({ allegations }),
  });
  return res.json();
}

// Report generation
export async function generateReport(token: string) {
  const res = await fetch(`${API}/ss/generate-report`, {
    method: 'POST',
    headers: { 'x-session-token': token },
  });
  return res.json();
}

export async function getReportStatus(token: string) {
  const res = await fetch(`${API}/ss/report-status`, { headers: { 'x-session-token': token } });
  return res.json();
}

// Reflection review
export async function submitReflection(token: string, file: File) {
  const res = await fetch(`${API}/ss/review-reflection`, {
    method: 'POST',
    headers: { 'x-session-token': token, 'x-filename': file.name, 'Content-Type': file.type || 'application/octet-stream' },
    body: file,
  });
  return res.json();
}

// Bot
export async function sendMessage(token: string, message: string) {
  const res = await fetch(`${API}/ss/chat`, {
    method: 'POST',
    headers: { 'x-session-token': token, 'Content-Type': 'application/json' },
    body: JSON.stringify({ message }),
  });
  return res.json();
}

// Stats (from SI widget)
export async function getRegulatorStats(regulator: string) {
  const res = await fetch(`${API}/si/widget/${regulator}`);
  return res.json();
}
